import { render, staticRenderFns } from "./CheckboxCustom.vue?vue&type=template&id=3098e748"
import script from "./CheckboxCustom.vue?vue&type=script&lang=js"
export * from "./CheckboxCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports